module.exports = __webpack_public_path__ + "f6d132521b058b57dbaec20a5881a633.svg";